import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import './styles/global.css';
import { useAuth } from './context/AuthContext';

// Core pages
import LoginPage from './pages/LoginPage';
import AyarlarPage from './pages/AyarlarPage';

// Shell
import AppShell from './components/common/AppShell';

// Admin
import AdminDashboard from './pages/admin/Dashboard';
import OgrencilerPage from './pages/admin/OgrencilerPage';
import OgrenciDetayPage from './pages/admin/OgrenciDetayPage';
import { KullanicilarPage, BildirimlerPage, SistemAnalizPage, TopluMesajPage } from './pages/admin/AdminPages';
import { SiniflarPage, DerslerPage } from './pages/admin/SinifDersProgrami';
import DenemeTopluGirisPage from './pages/admin/DenemeTopluGirisPage'; 
import TurkiyeGeneliDenemeSonuclariPage from './pages/admin/TurkiyeGeneliDenemeSonuclariPage';
import OgretmenPlanlamaPage from './pages/admin/OgretmenPlanlamaPage';
import OgrenciBildirimPage from './pages/OgrenciBildirimPage';
import AdminMufredatPage from './pages/admin/AdminMufredatPage';
import KelebekYonetimiPage from '../src/pages/admin/Kelebekyonetimipage';  

// 🚀 YENİ DERS PROGRAMI BİLEŞENİ IMPORTU
import DersProgramiPage from '../src/pages/admin/Dersprogramipage'; 

// Muhasebe imports
import MuhasebeDashboard  from './pages/muhasebe/MuhasebeDashboard';
import SozlesmelerPage    from './pages/muhasebe/SozlesmelerPage';
import SozlesmeAnalizPage    from './pages/muhasebe/SozlesmeAnalizPage';
import TahsilatPage       from './pages/muhasebe/TahsilatPage';
import GiderlerPage       from './pages/muhasebe/GiderlerPage';
import KasaPage           from './pages/muhasebe/KasaPage';
import MaaslarPage        from './pages/muhasebe/MaaslarPage';
import RaporlarPage       from './pages/muhasebe/RaporlarPage';
import StokPage             from './pages/muhasebe/StokPage';
import CrmPage              from './pages/muhasebe/CrmPage';
import EkDersPage           from './pages/muhasebe/EkDersPage';
import MateryalSatisPage    from './pages/muhasebe/MateryalSatisPage';
import IndirimSablonlariPage from './pages/muhasebe/IndirimSablonlariPage';
import { PlanlananGelirPage, PlanlananGiderPage } from './pages/muhasebe/PlanlananRaporPage';

// Teacher
import OgretmenDashboard from './pages/teacher/Dashboard';
import {
  DenemelerPage as TeacherDenemelerPage,
  OgretmenProgramPage,
} from './pages/teacher/TeacherPages';  
import YoklamaPageV2 from './pages/teacher/YoklamaPage';
import OdevPageV2 from './pages/teacher/OdevPage';
import MufredatPage from './pages/teacher/MufredatPage';

// Guidance
import { RehberDashboard } from './pages/shared/OtherDashboards';
import { GorusmelerPage, CalismaPrograPage, EtutlerPage, RandevularPage } from './pages/guidance/GuidancePages';

// Parent
import { VeliDashboard } from './pages/shared/OtherDashboards';
import { VeliBasariPage, VeliDevamsizlikPage } from './pages/parent/ParentPages';

// Student
import OgrenciDashboard from './pages/student/Dashboard';
import OgrenciKelebekPage  from '../src/pages/student/Ogrencikelebekpage';
import { OgrenciYoklamaPage, OgrenciProgramPage, OgrenciCalismaProgramlariPage, OgrenciOdevlerPage, EtutTalepPage, SiralamaPage } from './pages/student/StudentPages';
import {
  EtutYonetimiPage,
  RehberEtutYonetimiPage,
  OgretmenEtutleriPage,
  OgrenciEtutleriPage,
  VeliEtutleriPage,
} from './pages/etut/EtutYonetimiPages';

// ── Placeholder ───────────────────────────────────────────────
const Placeholder = ({ title, emoji = '🚧' }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
    <div style={{
      background: 'var(--bg-card)', border: '1px dashed rgba(255,255,255,0.08)',
      borderRadius: 16, padding: 48, textAlign: 'center',
    }}>
      <div style={{ fontSize: '3rem', marginBottom: 12 }}>{emoji}</div>
      <h3 style={{ fontFamily: 'var(--font-ui)', marginBottom: 8 }}>{title}</h3>
      <p style={{ color: 'var(--text-muted)', fontSize: '0.875rem' }}>
        Sayfa hazırlanıyor. Backend API bağlantısı kurulmuştur.
      </p>
    </div>
  </div>
);

// ── Root Redirect ─────────────────────────────────────────────
function RootRedirect() {
  const { user } = useAuth();
  const token = localStorage.getItem('dp_token');
  if (!token) return <Navigate to="/login" replace />;
  if (user?.rol === 'muhasebe') return <Navigate to="/muhasebe/dashboard" replace />;
  return <Navigate to="/admin/dashboard" replace />;
}

// ── Admin & Öğrenci İşleri ─────────────────────────────────────────────────────
const AdminRoutes = () => (
  <Routes>
    <Route element={<AppShell title="Yönetim Paneli" allowedRoles={['kurucu', 'ogrenci_isleri']} />}>
      <Route path="dashboard"         element={<AdminDashboard />} />
      <Route path="ogrenciler"        element={<OgrencilerPage />} />
      <Route path="ogrenciler/:id"    element={<OgrenciDetayPage />} />
      <Route path="devamsizlik"       element={<YoklamaPageV2 />} />
      <Route path="ogretmenler"       element={<KullanicilarPage defaultRol="ogretmen" />} />
      <Route path="veliler"           element={<KullanicilarPage defaultRol="veli" />} />
      <Route path="siniflar"          element={<SiniflarPage />} />
      <Route path="dersler"           element={<DerslerPage />} />
      <Route path="etut-yonetimi"     element={<EtutYonetimiPage />} />
      <Route path="denemeler"         element={<DenemeTopluGirisPage />} /> 
      <Route path="turkiye-geneli-deneme-sonuclari" element={<TurkiyeGeneliDenemeSonuclariPage />} />
      <Route path="mufredat-takibi"   element={<AdminMufredatPage />} />
      <Route path="ogretmen-planlama" element={<OgretmenPlanlamaPage />} />
      
      {/* ✅ Gelişmiş Yeni Ders Programı Bileşeni Buraya Bağlandı */}
      <Route path="ders-programi"     element={<DersProgramiPage />} />
      
      <Route path="sistem-analiz"     element={<SistemAnalizPage />} />
      <Route path="bildirimler"       element={<BildirimlerPage />} />
      <Route path="toplu-mesaj"       element={<TopluMesajPage />} />
      <Route path="kullanicilar"      element={<KullanicilarPage />} />
      <Route path="kelebek"           element={<KelebekYonetimiPage />} />
      <Route path="*"                 element={<Navigate to="dashboard" replace />} />
    </Route>
  </Routes>
);

// ── Öğretmen ──────────────────────────────────────────────────
const OgretmenRoutes = () => (
  <Routes>
    <Route element={<AppShell title="Öğretmen Paneli" allowedRoles={['ogretmen']} />}>
      <Route path="dashboard"   element={<OgretmenDashboard />} />
      <Route path="ogrenciler"  element={<OgrencilerPage />} />
      <Route path="yoklama"     element={<YoklamaPageV2 />} />
      <Route path="odevler"     element={<OdevPageV2 />} />
      <Route path="mufredat"    element={<MufredatPage />} />
      <Route path="etutlerim"   element={<OgretmenEtutleriPage />} />
      <Route path="denemeler"   element={<TeacherDenemelerPage />} /> 
      <Route path="program"     element={<OgretmenProgramPage />} />
      <Route path="randevular"  element={<RandevularPage mod="ogretmen" />} />
      <Route path="bildirimler" element={<OgrenciBildirimPage />} />
      <Route path="*"           element={<Navigate to="dashboard" replace />} />
    </Route>
  </Routes>
);

// ── Rehber ────────────────────────────────────────────────────
const RehberRoutes = () => (
  <Routes>
    <Route element={<AppShell title="Rehber Öğretmen Paneli" allowedRoles={['rehber_ogretmen']} />}>
      <Route path="dashboard"   element={<RehberDashboard />} />
      <Route path="ogrenciler"  element={<OgrencilerPage />} /> 
      <Route path="denemeler"   element={<DenemeTopluGirisPage />} />
      <Route path="devamsizlik" element={<YoklamaPageV2 />} />
      <Route path="gorusmeler"  element={<GorusmelerPage />} />
      <Route path="etut-yonetimi" element={<RehberEtutYonetimiPage />} />
      <Route path="programlar"  element={<CalismaPrograPage />} />
      <Route path="anketler"    element={<Placeholder title="Anket & Testler" emoji="📋" />} />
      <Route path="etutler"     element={<EtutlerPage />} />
      <Route path="randevular"  element={<RandevularPage mod="rehber" />} />
      <Route path="bildirimler" element={<BildirimlerPage />} /> 
      <Route path="*"           element={<Navigate to="dashboard" replace />} />
    </Route>
  </Routes>
);

// ── Veli ──────────────────────────────────────────────────────
const VeliRoutes = () => (
  <Routes>
    <Route element={<AppShell title="Veli Paneli" allowedRoles={['veli']} />}>
      <Route path="dashboard"   element={<VeliDashboard />} />
      <Route path="basari"      element={<VeliBasariPage />} />
      <Route path="devamsizlik" element={<VeliDevamsizlikPage />} />
      <Route path="etutler"     element={<VeliEtutleriPage />} />
      <Route path="program"     element={<OgrenciProgramPage />} />
      <Route path="randevu"     element={<RandevularPage mod="veli" />} />
      <Route path="bildirimler" element={<OgrenciBildirimPage />} />
      <Route path="*"           element={<Navigate to="dashboard" replace />} />
    </Route>
  </Routes>
);

// ── Öğrenci ───────────────────────────────────────────────────
const OgrenciRoutes = () => (
  <Routes>
    <Route element={<AppShell title="Öğrenci Paneli" allowedRoles={['ogrenci']} />}>
      <Route path="dashboard"      element={<OgrenciDashboard />} />
      <Route path="basari"         element={<Placeholder title="Başarı Detayı" emoji="📊" />} />
      <Route path="siralama"       element={<SiralamaPage />} />
      <Route path="odevler"        element={<OgrenciOdevlerPage />} />
      <Route path="yoklama"        element={<OgrenciYoklamaPage />} />
      <Route path="etutlerim"      element={<OgrenciEtutleriPage />} />
      <Route path="program"        element={<OgrenciProgramPage />} />
      <Route path="calisma"        element={<OgrenciCalismaProgramlariPage />} />
      <Route path="randevu"        element={<RandevularPage mod="ogrenci" />} />
      <Route path="etut-talep"     element={<EtutTalepPage />} />
      <Route path="bildirimler"    element={<OgrenciBildirimPage />} />
      <Route path="kelebek"        element={<OgrenciKelebekPage />} />
      <Route path="*"              element={<Navigate to="dashboard" replace />} />
    </Route>
  </Routes>
);

// ── Ayarlar ───────────────────────────────────────────────────
const AyarlarRoutes = () => (
  <Routes>
    <Route element={<AppShell title="Ayarlar" />}>
      <Route index element={<AyarlarPage />} />
    </Route>
  </Routes>
);

// ── Muhasebe ──────────────────────────────────────────────────
const MuhasebeRoutes = () => (
  <Routes>
    <Route element={<AppShell title="Muhasebe Paneli" allowedRoles={['kurucu', 'muhasebe', 'ogrenci_isleri']} />}>
      <Route path="dashboard"          element={<MuhasebeDashboard />} />
      <Route path="sozlesmeler"        element={<SozlesmelerPage />} />
      <Route path="sozlesme-analizleri" element={<SozlesmeAnalizPage />} />
      <Route path="tahsilat"           element={<TahsilatPage />} />
      <Route path="giderler"           element={<GiderlerPage />} />
      <Route path="planlanan-gelir"    element={<PlanlananGelirPage />} />
      <Route path="planlanan-gider"    element={<PlanlananGiderPage />} />
      <Route path="kasa"               element={<KasaPage />} />
      <Route path="maaslar"            element={<MaaslarPage />} />
      <Route path="raporlar"           element={<RaporlarPage />} />
      <Route path="stok"               element={<StokPage />} />
      <Route path="crm"                element={<CrmPage />} />
      <Route path="ek-ders"            element={<EkDersPage />} />
      <Route path="materyal-satis"     element={<MateryalSatisPage />} />
      <Route path="indirim-sablonlari" element={<IndirimSablonlariPage />} />
      <Route path="*"                  element={<Navigate to="dashboard" replace />} />
    </Route>
  </Routes>
);

// ── App ───────────────────────────────────────────────────────
export default function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: '#FFFFFF',
              color: '#0F1E3D',
              border: '1.5px solid #E2E8F0',
              borderRadius: 12,
              fontFamily: 'var(--font-ui)',
              fontSize: '0.875rem',
              boxShadow: '0 4px 16px rgba(15,30,61,0.1)',
            },
            success: { iconTheme: { primary: '#10B981', secondary: '#000' } },
            error:   { iconTheme: { primary: '#EF4444', secondary: '#000' } },
          }}
        />
        <Routes>
          <Route path="/"           element={<RootRedirect />} />
          <Route path="/login"      element={<LoginPage />} />
          <Route path="/admin/*"    element={<AdminRoutes />} />
          <Route path="/ogretmen/*" element={<OgretmenRoutes />} />
          <Route path="/rehber/*"   element={<RehberRoutes />} />
          <Route path="/veli/*"     element={<VeliRoutes />} />
          <Route path="/ogrenci/*"  element={<OgrenciRoutes />} />
          <Route path="/ayarlar/*"  element={<AyarlarRoutes />} />
          <Route path="/muhasebe/*" element={<MuhasebeRoutes />} />
          <Route path="*"           element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
